PageApp.Ent.Errors = Backbone.Collection.extend({
})
